import React from "react"
import ReactDOM from "react-dom/client"

import {Provider} from "react-redux"
import {HelmetProvider} from "react-helmet-async"

import App from "./App"

import {RecoilRoot} from "recoil"
import reportWebVitals from "@src/reportWebVitals"
import store from "@src/store"
import './i18n'


const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
    <RecoilRoot>
        <Provider store={store}>
            <HelmetProvider>
                <App/>
            </HelmetProvider>
        </Provider>
    </RecoilRoot>
)

reportWebVitals()
